// TrueMens — Turning Point
// Minimal, dependency-free JS: scroll-reveal, a light parallax
// drift on secondary campaign photography, and the two
// accordions (benefits + FAQ). No form submission logic is
// wired up (see index.html comment above #shopify-waitlist-form)
// — that arrives with the Shopify Forms embed.

(function () {
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var revealEls = document.querySelectorAll(".tp-reveal");
  if (!("IntersectionObserver" in window) || !revealEls.length) {
    revealEls.forEach(function (el) { el.classList.add("tp-is-visible"); });
  } else {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("tp-is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  }

  if (!reduceMotion) {
    var parallaxWrappers = Array.prototype.slice.call(document.querySelectorAll("[data-parallax]"));
    var parallaxTargets = parallaxWrappers
      .map(function (wrapper) {
        var img = wrapper.querySelector("img");
        if (!img) return null;
        img.style.transform = "scale(1.1)";
        img.style.willChange = "transform";
        return { img: img, factor: parseFloat(wrapper.getAttribute("data-parallax")) || 0.06, wrapper: wrapper };
      })
      .filter(Boolean);

    if (parallaxTargets.length) {
      var ticking = false;
      var applyParallax = function () {
        var viewportH = window.innerHeight;
        parallaxTargets.forEach(function (t) {
          var rect = t.wrapper.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > viewportH) return;
          var offset = (rect.top - viewportH / 2) * t.factor;
          t.img.style.transform = "scale(1.1) translateY(" + offset.toFixed(1) + "px)";
        });
        ticking = false;
      };
      window.addEventListener(
        "scroll",
        function () {
          if (!ticking) {
            window.requestAnimationFrame(applyParallax);
            ticking = true;
          }
        },
        { passive: true }
      );
      applyParallax();
    }
  }

  // Accordions — one open at a time per group (benefits, FAQ).
  var groups = document.querySelectorAll("[data-accordion-group]");
  groups.forEach(function (group) {
    var triggers = Array.prototype.slice.call(group.querySelectorAll(".tp-accordion-trigger"));
    triggers.forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        var isOpen = trigger.getAttribute("aria-expanded") === "true";
        triggers.forEach(function (t) { t.setAttribute("aria-expanded", "false"); });
        trigger.setAttribute("aria-expanded", isOpen ? "false" : "true");
      });
    });
  });
})();
